import { getAxiosClient } from "../../axios-client";
import {
  OrdersDetailsPricelistByIdSubcontractorBody,
  OrdersDetailsPricelistByIdSubcontractorResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const getOrdersDetailsPricelistByIdSubcontractor = async (
  body: OrdersDetailsPricelistByIdSubcontractorBody
) => {
  return await axiosClient.ax.post<OrdersDetailsPricelistByIdSubcontractorResponse>(
    "/Orders/OrdersDetailsPricelistGetByIdSubcontractor",
    body
  );
};
